export class CompleteRegistrationModel {
  stripeToken: string;
  planStripId: string;
  billing: string;
  users: number;
  skus: number;
  orders: number;
}